import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card } from '@/components/ui/card';
import { Cookie, Check, X } from 'lucide-react';

export const Cookies = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-4"></div>
            <h1
              className="text-4xl md:text-5xl font-bold mb-4"
              style={{ color: 'var(--navy-900)' }}
            >
              Cookie-Richtlinie
            </h1>
            <p className="text-lg" style={{ color: 'var(--gray-600)' }}>
              Informationen zur Verwendung von Cookies auf dieser Website
            </p>
          </div>

          {/* Intro */}
          <Card className="glass-card p-8 mb-8">
            <div className="flex items-start gap-4">
              <Cookie className="h-8 w-8" style={{ color: 'var(--gold-600)' }} />
              <div>
                <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--navy-800)' }}>
                  Was sind Cookies?
                </h2>
                <p className="text-sm" style={{ color: 'var(--gray-700)' }}>
                  Cookies sind kleine Textdateien, die beim Besuch einer Website auf Ihrem Computer 
                  oder mobilen Gerät gespeichert werden. Sie helfen dabei, die Website funktionsfähig 
                  zu machen und Ihr Nutzererlebnis zu verbessern.
                </p>
              </div>
            </div>
          </Card>

          {/* Cookie-Typen */}
          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Welche Cookies verwenden wir?
            </h2>

            <div className="space-y-6">
              {/* Notwendige Cookies */}
              <div className="border-l-4 pl-4" style={{ borderLeftColor: 'var(--success-600)' }}>
                <div className="flex items-center gap-2 mb-2">
                  <Check className="h-5 w-5" style={{ color: 'var(--success-600)' }} />
                  <h3 className="text-lg font-semibold" style={{ color: 'var(--navy-700)' }}>
                    Notwendige Cookies (immer aktiv)
                  </h3>
                </div>
                <p className="text-sm mb-3" style={{ color: 'var(--gray-700)' }}>
                  Diese Cookies sind für den Betrieb der Website unbedingt erforderlich und können 
                  nicht deaktiviert werden.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-gray-200">
                        <th className="text-left py-2" style={{ color: 'var(--navy-700)' }}>Name</th>
                        <th className="text-left py-2" style={{ color: 'var(--navy-700)' }}>Zweck</th>
                        <th className="text-left py-2" style={{ color: 'var(--navy-700)' }}>Dauer</th>
                      </tr>
                    </thead>
                    <tbody style={{ color: 'var(--gray-700)' }}>
                      <tr className="border-b border-gray-100">
                        <td className="py-2 font-mono text-xs">admin_token</td>
                        <td className="py-2">Admin-Login-Session</td>
                        <td className="py-2">12 Stunden</td>
                      </tr>
                      <tr>
                        <td className="py-2 font-mono text-xs">consent_preferences</td>
                        <td className="py-2">Speicherung Ihrer Cookie-Einstellungen</td>
                        <td className="py-2">1 Jahr</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="text-xs mt-3" style={{ color: 'var(--gray-600)' }}>
                  <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)
                </p>
              </div>

              {/* Funktionale Cookies */}
              <div className="border-l-4 pl-4" style={{ borderLeftColor: 'var(--gold-600)' }}>
                <div className="flex items-center gap-2 mb-2">
                  <Check className="h-5 w-5" style={{ color: 'var(--gold-600)' }} />
                  <h3 className="text-lg font-semibold" style={{ color: 'var(--navy-700)' }}>
                    Funktionale Cookies (optional)
                  </h3>
                </div>
                <p className="text-sm mb-3" style={{ color: 'var(--gray-700)' }}>
                  Diese Cookies ermöglichen erweiterte Funktionen und Personalisierung.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-gray-200">
                        <th className="text-left py-2" style={{ color: 'var(--navy-700)' }}>Name</th>
                        <th className="text-left py-2" style={{ color: 'var(--navy-700)' }}>Zweck</th>
                        <th className="text-left py-2" style={{ color: 'var(--navy-700)' }}>Dauer</th>
                      </tr>
                    </thead>
                    <tbody style={{ color: 'var(--gray-700)' }}>
                      <tr>
                        <td className="py-2 font-mono text-xs">user_preferences</td>
                        <td className="py-2">Speicherung persönlicher Einstellungen</td>
                        <td className="py-2">6 Monate</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="text-xs mt-3" style={{ color: 'var(--gray-600)' }}>
                  <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
                </p>
              </div>

              {/* Analyse Cookies */}
              <div className="border-l-4 pl-4" style={{ borderLeftColor: 'var(--navy-600)' }}>
                <div className="flex items-center gap-2 mb-2">
                  <X className="h-5 w-5" style={{ color: 'var(--gray-400)' }} />
                  <h3 className="text-lg font-semibold" style={{ color: 'var(--navy-700)' }}>
                    Analyse-Cookies (aktuell nicht verwendet)
                  </h3>
                </div>
                <p className="text-sm mb-3" style={{ color: 'var(--gray-700)' }}>
                  Wir verwenden derzeit keine Analyse-Cookies. Sollten wir in Zukunft 
                  Analyse-Tools einsetzen, erfolgt dies nur mit Ihrer ausdrücklichen Einwilligung.
                </p>
                <p className="text-xs" style={{ color: 'var(--gray-600)' }}>
                  Mögliche zukünftige Tools: Google Analytics, Matomo (mit Einwilligung)
                </p>
              </div>

              {/* Marketing Cookies */}
              <div className="border-l-4 pl-4" style={{ borderLeftColor: 'var(--gray-400)' }}>
                <div className="flex items-center gap-2 mb-2">
                  <X className="h-5 w-5" style={{ color: 'var(--gray-400)' }} />
                  <h3 className="text-lg font-semibold" style={{ color: 'var(--navy-700)' }}>
                    Marketing-Cookies (nicht verwendet)
                  </h3>
                </div>
                <p className="text-sm" style={{ color: 'var(--gray-700)' }}>
                  Wir verwenden keine Marketing- oder Tracking-Cookies von Drittanbietern.
                </p>
              </div>
            </div>
          </Card>

          {/* Cookie-Verwaltung */}
          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Wie können Sie Cookies verwalten?
            </h2>
            
            <div className="space-y-4 text-sm" style={{ color: 'var(--gray-700)' }}>
              <p>
                Sie haben verschiedene Möglichkeiten, Cookies zu verwalten und zu löschen:
              </p>

              <div>
                <h3 className="font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  1. Browser-Einstellungen
                </h3>
                <p>
                  In Ihrem Browser können Sie Cookies blockieren oder löschen. Bitte beachten Sie, 
                  dass dadurch möglicherweise nicht alle Funktionen der Website verfügbar sind.
                </p>
              </div>

              <div>
                <h3 className="font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  Anleitungen für gängige Browser:
                </h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>
                    <strong>Google Chrome:</strong> Einstellungen → Datenschutz und Sicherheit → Cookies
                  </li>
                  <li>
                    <strong>Mozilla Firefox:</strong> Einstellungen → Datenschutz & Sicherheit → Cookies und Website-Daten
                  </li>
                  <li>
                    <strong>Safari:</strong> Einstellungen → Datenschutz → Cookies und Website-Daten
                  </li>
                  <li>
                    <strong>Microsoft Edge:</strong> Einstellungen → Cookies und Websiteberechtigungen
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  2. Cookie-Einstellungen auf dieser Website
                </h3>
                <p className="mb-3">
                  Sie können Ihre Cookie-Einstellungen jederzeit in den Website-Einstellungen anpassen 
                  (sofern implementiert: Cookie-Banner oder Einstellungen-Link im Footer).
                </p>
              </div>
            </div>
          </Card>

          {/* Drittanbieter */}
          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Cookies von Drittanbietern
            </h2>
            <p className="text-sm" style={{ color: 'var(--gray-700)' }}>
              Aktuell setzen wir keine Cookies von Drittanbietern ein. Sollten wir in Zukunft 
              Dienste von Drittanbietern nutzen (z.B. Google Maps, YouTube-Videos), werden diese 
              Dienste nur mit Ihrer ausdrücklichen Einwilligung geladen und können eigene Cookies setzen.
            </p>
          </Card>

          {/* Weitere Informationen */}
          <Card className="glass-card p-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Weitere Informationen
            </h2>
            <p className="text-sm mb-4" style={{ color: 'var(--gray-700)' }}>
              Detaillierte Informationen zum Datenschutz und zur Verarbeitung Ihrer personenbezogenen 
              Daten finden Sie in unserer{' '}
              <a href="/datenschutz" className="hover:underline font-semibold" style={{ color: 'var(--navy-600)' }}>
                Datenschutzerklärung
              </a>.
            </p>
            <p className="text-sm" style={{ color: 'var(--gray-700)' }}>
              Bei Fragen zu unseren Cookies kontaktieren Sie uns bitte unter{' '}
              <a href="mailto:info@retail-invest.com" className="hover:underline font-semibold" style={{ color: 'var(--navy-600)' }}>
                info@retail-invest.com
              </a>.
            </p>
            <p className="text-sm mt-4" style={{ color: 'var(--gray-600)' }}>
              <strong>Stand:</strong> Januar 2025
            </p>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Cookies;
